/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowFigureASquareUpIcon20Light = forwardRef('ArrowFigureASquareUpIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M9.5 13.5A.5.5 0 0 1 9 13V6.781l-2.116 2.54a.5.5 0 1 1-.768-.641l2.232-2.678a1.5 1.5 0 0 1 2.304 0l2.232 2.678a.5.5 0 0 1-.768.64L10 6.781V13a.5.5 0 0 1-.5.5Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.5 17A3.5 3.5 0 0 1 2 13.5v-8A3.5 3.5 0 0 1 5.5 2h8A3.5 3.5 0 0 1 17 5.5v8a3.5 3.5 0 0 1-3.5 3.5h-8ZM3 13.5A2.5 2.5 0 0 0 5.5 16h8a2.5 2.5 0 0 0 2.5-2.5v-8A2.5 2.5 0 0 0 13.5 3h-8A2.5 2.5 0 0 0 3 5.5v8Z" })));
});
